module.exports = __webpack_public_path__ + "img/niunai1.a974b4ed.jpg";